import { Input, Select, Space } from 'antd';
import { t } from 'i18next';
import { TemplateSaveActionEnum } from '../ExportFileTypes.ts';

export interface IExportTemplateCardProps {
  selectedTemplate: string;
  setTemplateSaveAction: (value: TemplateSaveActionEnum) => void;
  setNewTemplateName: (value: string) => void;
  templateSaveAction: TemplateSaveActionEnum;
}

/**
 * Componente per la selezione del template di esportazione
 */
export function ExportTemplateCard(props: IExportTemplateCardProps) {
  const {
    selectedTemplate,
    setTemplateSaveAction,
    setNewTemplateName,
    templateSaveAction,
  } = props;

  return (
    <Space.Compact style={{ width: '100%' }}>
      <Select
        style={{ width: '100%' }}
        placeholder={t(
          'export-file-button.save-action-select.placeholder.update-template-to-export',
          'Aggiornamento Template',
        )}
        defaultValue={TemplateSaveActionEnum.NO_SAVE}
        options={[
          {
            label: t(
              'export-file-button.save-action-select.non-salvare-template',
              'Non salvare il Template',
            ),
            value: TemplateSaveActionEnum.NO_SAVE,
          },
          ...(selectedTemplate != null && selectedTemplate.length > 0
            ? [
                {
                  label: t(
                    'export-file-button.save-action-select.aggiorna-template',
                    'Aggiorna il Template',
                  ),
                  value: TemplateSaveActionEnum.UPDATE_TEMPLATE,
                },
              ]
            : []),
          {
            label: t(
              'export-file-button.save-action-select.salva-nuovo-template',
              'Salva come nuovo Template',
            ),
            value: TemplateSaveActionEnum.NEW_TEMPLATE,
          },
        ]}
        onChange={(option: TemplateSaveActionEnum) => {
          setTemplateSaveAction(option);
        }}
      />
      {templateSaveAction &&
        templateSaveAction == TemplateSaveActionEnum.NEW_TEMPLATE && (
          <Input
            type="secondary"
            placeholder={t(
              'export-file-button.save-action-select.input-nuovo-template.placeholder',
              'Nome del nuovo Template',
            )}
            onChange={e => {
              setNewTemplateName(e.target.value);
            }}
          />
        )}
    </Space.Compact>
  );
}
